module.exports = __webpack_public_path__ + "img/deliveryIndustrySolution_EN.jpg";